import {enumReduce, Values} from '@wix/devzai-utils-common';
import {WixAppRuntimeEnvironment, WixAppsIds} from '@wix/devzai-common-wix';

export const DoppeLinkedWixSiteSupportedTpas = {
    Inbox: WixAppsIds.Inbox,
    Blog: WixAppsIds.Blog,
    StoresNew: WixAppsIds.StoresNew,
    Stores: WixAppsIds.Stores,
    Booking: WixAppsIds.Booking,
    PricingPlans: WixAppsIds.PricingPlans,
    WixForms: WixAppsIds.WixForms,
    Events: WixAppsIds.Events,
    Hopp: WixAppsIds.Hopp,
} as const;

export type DoppeLinkedWixSiteSupportedTpas = Values<typeof DoppeLinkedWixSiteSupportedTpas>;

export const DoppeSupportedWixTpas = {
    ...DoppeLinkedWixSiteSupportedTpas,
    HoppCreators: WixAppsIds.HoppCreators,
    HoppCreatorsStaging: WixAppsIds.HoppCreatorsStaging,
    HoppCreatorsProduction: WixAppsIds.HoppCreatorsProduction,
    HoppCreatorsLocal: WixAppsIds.HoppCreatorsLocal,
} as const;

export type DoppeSupportedWixTpas = Values<typeof DoppeSupportedWixTpas>;

export const DoppeUserInstallableWixTpas = enumReduce(DoppeSupportedWixTpas, [
    DoppeSupportedWixTpas.StoresNew,
    DoppeSupportedWixTpas.Stores,
    DoppeSupportedWixTpas.Blog,
    DoppeSupportedWixTpas.Booking,
    DoppeSupportedWixTpas.WixForms,
    DoppeSupportedWixTpas.Events
]);

export type DoppeUserInstallableWixTpas = Values<typeof DoppeUserInstallableWixTpas>;

export const DoppeDataBindableWixTpas = enumReduce(DoppeSupportedWixTpas, [
    DoppeSupportedWixTpas.PricingPlans,
    DoppeSupportedWixTpas.StoresNew,
    DoppeSupportedWixTpas.Stores,
    DoppeSupportedWixTpas.Blog,
    DoppeSupportedWixTpas.Booking,
    DoppeSupportedWixTpas.Events
]);

export type DoppeDataBindableWixTpas = Values<typeof DoppeDataBindableWixTpas>;

export const DoppeAutoInstalledWixTpasIds = [
    DoppeSupportedWixTpas.Inbox
] satisfies DoppeSupportedWixTpas[]

export function doppeResolveCreatorsEconomyWixAppIdByEnvironment (env: WixAppRuntimeEnvironment) {
    switch (env) {
        case WixAppRuntimeEnvironment.Local:
            return DoppeSupportedWixTpas.HoppCreatorsLocal;
        case WixAppRuntimeEnvironment.Staging:
            return DoppeSupportedWixTpas.HoppCreatorsStaging;
        case WixAppRuntimeEnvironment.Production:
            return DoppeSupportedWixTpas.HoppCreatorsProduction;
    }
}